var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-finish" },
    [
      _vm._m(0),
      _c(
        "v-btn",
        {
          staticClass: "mt-5",
          attrs: { block: "", color: "primary" },
          on: { click: _vm.onGotoStart }
        },
        [_vm._v("zurück zur Startseite")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "text-center py-10" }, [
      _vm._v("Vielen Dank,"),
      _c("br"),
      _vm._v("Ihr Vertrag wurde abgesendet.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }